<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{content}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="dialogRef.close(false)">{{no}}</button>
  <button mat-button (click)="dialogRef.close(true)" color="warn">{{yes}}</button>
</div>
